import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SalesHomePage from './SalesHomePage';
import ProductionHomePage from './ProductionHomePage';
import QCHomePage from './QCHomePage';
import WarehouseHomePage from './WarehouseHomePage';
import SupervisorHomePage from './SupervisorHomePage';
import HomePage from './HomePage';

const DepartmentHomePage = () => {
  const { department } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If user has a department but is accessing the wrong department page, redirect to their department
    if (user?.department_code && department && department !== user.department_code.toLowerCase()) {
      navigate(`/home/${user.department_code.toLowerCase()}`);
    }
  }, [department, user, navigate]);

  // Map department codes to components
  const getDepartmentComponent = () => {
    const dept = department?.toLowerCase();

    switch (dept) {
      case 'sales':
        return <SalesHomePage />;
      case 'prod':
      case 'production':
        return <ProductionHomePage />;
      case 'qc':
      case 'quality':
        return <QCHomePage />;
      case 'wh':
      case 'warehouse':
      case 'ware':
        return <WarehouseHomePage />;
      case 'supervisor':
      case 'sup':
        return <SupervisorHomePage />;
      default:
        // If no department or unknown department, show generic home page
        return <HomePage />;
    }
  };

  return getDepartmentComponent();
};

export default DepartmentHomePage;